<script>
import {XCircleIcon} from '@heroicons/vue/20/solid'

export default {
    props: {
        errors: {
            type: Array,
            default: () => []
        }
    },

    components: {
        XCircleIcon
    },

    computed: {
        errorMessage() {
            if (this.errors.length > 1) {
                return this.$t('form.error.1') + ' ' + this.errors.length + ' ' + this.$t('form.error.2')
            } else {
                return this.$t('form.error.1.single') + ' ' + this.errors.length + ' ' + this.$t('form.error.2.single')
            }
        }
    },
}
</script>

<template>
    <div class="rounded-md bg-red-50 p-4">
        <div class="flex">
            <div class="flex-shrink-0">
                <XCircleIcon class="h-5 w-5 text-red-400" aria-hidden="true"/>
            </div>
            <div class="ml-3">
                <h3 class="text-sm font-medium text-red-800">
                    {{ errorMessage }}
                </h3>
                <div class="mt-2 text-sm text-red-700">
                    <ul role="list" class="list-disc space-y-1 pl-5">
                        <li v-for="error in errors">{{ error }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
